import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
// import UpdateIcon from '@mui/icons-material/Update';
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
// import EditNotificationsIcon from '@mui/icons-material/EditNotifications';

// import LockIcon from '@mui/icons-material/Lock';
import AppLink from "../../../../../../components/AppLink";

const OtherSettingsPage = () => {
  return (
    <Box sx={{ p: 1 }}>
      <List
        sx={{ width: "100%", bgcolor: "background.paper", maxWidth: "500px" }}
      >
        <ListItem disablePadding>
          <AppLink
            to="#"
            doNotUseButton
            
            style={{
              display: "block",
              width: "100%",
            }}
          >
            <ListItemButton disabled>
              <ListItemIcon>
                <AccountTreeIcon />
              </ListItemIcon>
              <ListItemText
                primary="Email Templates"
                secondary={"Coming soon"}
              />
            </ListItemButton>
          </AppLink>
        </ListItem>

        <ListItem disablePadding>
          <AppLink
            to="banks"
            doNotUseButton
            
            style={{
              display: "block",
              width: "100%",
            }}
          >
            <ListItemButton >
              <ListItemIcon>
                <AccountBalanceIcon />
              </ListItemIcon>
              <ListItemText
                primary="Banks"
                secondary={"All the known banks on the platform"}
              />
            </ListItemButton>
          </AppLink>
        </ListItem>
      </List>
    </Box>
  );
};

export default  OtherSettingsPage;
